import styled from "styled-components";
import { Card, CardProps } from "@material-ui/core";
import { selectionYellow } from "styles/colors";

export const CommentContainer = styled(Card)<CardProps & { selected?: boolean; error?: number }>`
    padding: ${({ theme }) => theme.spacing(1)}px;
    margin-bottom: ${({ theme }) => theme.spacing(1)}px;
    cursor: pointer;
    border: 1px solid transparent;

    .MuiButton-root {
        min-width: 32px;
    }

    .MuiButtonBase-root {
        padding: 0;
    }

    ${({ selected, error, theme }) => `
        background-color: ${selected ? selectionYellow : theme.palette.grey["200"]};
        border: 1px solid ${error ? theme.palette.error.main : "transparent"};
    `}
`;
